import axios from '../../config/axios';
import {BASE_URL_API} from '../../config/env';
import useQuery2 from '../../hooks/useQuery2';

export const getCustomerOrders = () =>
    axios({
        method: 'GET',
        url: `${BASE_URL_API}/api/v1/orders`
    }).then(({data}) => data);

export const useGetCustomerOrders = () => {
    return useQuery2({
        queryKey: ['app-public.customer_orders'],
        queryFn: getCustomerOrders
    });
}

